module.exports = __webpack_public_path__ + "static/media/cassie-matias-202984-unsplash.e38b480b.jpg";